module.exports = __webpack_public_path__ + "assets/img/52.8b318c65.png";